import { queryTradeConfig, queryBlockChains, queryUserInfo } from '@/api/dex'
const useDexStore = defineStore('dex', () => {
  /**
   * userInfo
   */
  const userInfo = ref<any>(null)

  /**
   * 当前网络chain
   */
  const chain = ref<string>('solana')

  /**
   * dex配置  滑点和网络费用
   */
  const dexConfig = ref<any>(null)

  /**
   * 链列表
   */
  const blockChains = ref<any>(null)

  /**
   * 不再提示 避免交易失败
   */
  const isAvoidPrompts = ref<boolean>(false)

  /**
   * 不再提示 交易失败
   */
  const isFailedPrompts = ref<boolean>(false)

  /**
   * 链Map
   */
  const blockChainsMap = computed(() => {
    if (!blockChains.value) return {}
    const result: any = {}
    blockChains.value.forEach((chains: any) => {
      result[chains.chainId] = chains
    })
    return result
  })

  /**
   * 当前链详情
   */
  const currentChainInfo = computed(() => {
    return blockChainsMap.value[chain.value]
  })

  /**
   * 当前链的gas fee数据
   */
  const chainFeeData = computed(() => {
    return currentChainInfo.value?.chainFeeData ?? {}
  })

  /**
   * 获取dex配置
   */
  const queryDexConfig = async () => {
    try {
      const { data } = await queryTradeConfig()
      dexConfig.value = data
    } catch (e) {
      console.log('e', e)
    }
  }

  /**
   * 获取支持的链列表
   */
  const queryChains = async () => {
    try {
      const { data } = await queryBlockChains()
      blockChains.value = data.filter((item: any) => {
        return item.chainId === chain.value
      })
    } catch (e) {
      console.log('e', e)
    }
  }

  /**
   * 获取用户信息
   */
  const getUserInfo = async () => {
    try {
      const { data } = await queryUserInfo()
      userInfo.value = data
    } catch (e: any) {
      console.log('e', e)
    }
  }

  // 不再提示 避免交易失败
  const setIsAvoidPrompts = (bool: boolean) => {
    isAvoidPrompts.value = bool
  }

  // 不再提示 交易失败
  const setIsFailedPrompts = (bool: boolean) => {
    isFailedPrompts.value = bool
  }

  return {
    userInfo,
    chain,
    dexConfig,
    blockChains,
    currentChainInfo,
    chainFeeData,
    blockChainsMap,
    queryDexConfig,
    queryChains,
    getUserInfo,
    isAvoidPrompts,
    setIsAvoidPrompts,
    isFailedPrompts,
    setIsFailedPrompts,
  }
})

export default useDexStore
